import { Label, Text } from '@fluentui/react';
import { textProp } from 'global/Application';
import { IBooleanValue } from 'model/FlexibleAttributeModel';
import React, { useMemo } from 'react';
import ToggleOptions, { IToggleOptionsProps } from './ToggleOptions';
import { IToggleOption } from './ToggleOptions/IToggleOption.type';

export type IBooleanToggleOption = IToggleOption<IBooleanValue>;

interface IOptionControlProps extends Partial<IToggleOptionsProps<IBooleanValue>> {
    label?: string;
    fieldValueOnChange?: (event: React.MouseEvent<HTMLElement, MouseEvent>, value: IBooleanValue | undefined) => void;
    defaultFieldValue?: IBooleanValue;
    disabled?: boolean;
    styles?: any;
    unclick?: boolean;
    clearDisabled?: boolean;
}

const DEFAULT_OPTIONS: IToggleOption<IBooleanValue>[] = [
    { key: 'Yes', text: 'Yes', data: { type: 'bool', value: true } },
    { key: 'No', text: 'No', data: { type: 'bool', value: false } },
]

const OptionControl: React.FunctionComponent<IOptionControlProps> = (props) => {

    const options: IToggleOption<IBooleanValue>[] = useMemo(() => {
        return props.options ?? DEFAULT_OPTIONS;
    }, [props.options]);

    let selectedKey: string | null = null;

    if (props.defaultFieldValue?.value === true)
        selectedKey = "Yes";
    else if (props.defaultFieldValue?.value === false)
        selectedKey = "No";

    if (props.disabled) {
        return (
            <div style={textProp.root.style}>
                <Label styles={textProp.label}>{props.label}</Label>
                <Text styles={textProp.textStyles}>{selectedKey ?? '---'}</Text>
            </div>
        );
    }

    return (
        <ToggleOptions
            label={props.label}
            options={options}
            onChange={(event, option) => {
                props.fieldValueOnChange?.(event as React.MouseEvent<HTMLElement, MouseEvent>, option?.data);
            }}
            defaultSelectedKey={selectedKey}
            clearDisabled={props.clearDisabled}
            disabled={props.disabled}
            styles={props.styles}
            unclick={props.unclick}
        />
    )
}


export default OptionControl